// extracted by mini-css-extract-plugin
export var bigText = "Header-module--big-text--6909d";
export var header = "Header-module--header--357cc";
export var layout = "Header-module--layout--499ea";
export var logo = "Header-module--logo--edb3a";
export var richText = "Header-module--rich-text--d5cbd";
export var text = "Header-module--text--c7c04";